export enum PermissionTypeEnum {
    UserAgreement = 1,
    Email = 2,
    Sms = 3,
}